import * as React from 'react';
import Investment from 'src/entities/Investment';
import Project from 'src/entities/Project';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';

interface Props {
  project: Project;
  investment: Investment;
  questionId?: boolean;
  handleQuestion(id: boolean): void;
  handleConfirmImport(): void;

  handleModifyImport(): void;
}

const ConfirmImportComponent: React.StatelessComponent<Props> = (props: Props) => {
  const investedValue = NumberFormater.euros(props.investment.amountInvested);

  const feeValue = NumberFormater.euros(1.21 * (props.investment.fees * 0.01) *
    props.investment.amountInvested);

  const totalValue = NumberFormater.euros((1.21 * (props.investment.fees * 0.01) + 1) *
    props.investment.amountInvested);

  let equity = (props.investment.quantityTickets * props.project.sharePercentage).toString();

  equity = parseFloat(equity).toLocaleString('es-ES', {minimumFractionDigits: 4});

  return (
    <div>
      <div className="gap-50" />
      {
        props.investment.person!.personType === 'juridical' ?
          <div>
            <p className="f-s-20 f-w-100">
              ¿Esta inversión representa un activo esencial de la compañía? *
            </p>
            <form className="padding-l-10">
              <div 
                className="radio"
              >
                <input
                  type="radio"
                  id={'opt1'}
                  name="opt"
                  onChange={() => props.handleQuestion(true)}
                />
                <label 
                  className="f-s-20 f-w-100"
                  htmlFor={'opt1'}
                >
                  Sí
                </label>
              </div>
              <div 
                className="radio"
              >
                <input
                  type="radio"
                  id={'opt2'}
                  name="opt"
                  onChange={() => props.handleQuestion(false)}
                />
                <label 
                  className="f-s-20 f-w-100"
                  htmlFor={'opt2'}
                >
                  No
                </label>
              </div>
            </form>
          </div> :
          null
      }

      <div className="gap-50" />
      <p className="f-s-20 f-w-100">
        Importe comprometido:
      </p>
      <div className="gap-10"/>
      <div className="row">
        <div className="col-sm-6">
          {props.investment.quantityTickets > 0 ?
            <div className="icon-content pledge">
              <img
                alt="wallet"
                className="icon"
                src="/img/small-wallet.png"
              />
              <p className="inline-block f-s-20">
                Tickets comprometidos:<br/>
                <strong>{props.investment.quantityTickets}</strong>
              </p>
            </div>
            : null
          }
          <div className="icon-content pledge">
            <img
              alt="Euro"
              className="icon"
              src="/img/small-euro.png"
            />
            <p className="inline-block f-s-20">
              Capital comprometido:<br/>
              <strong>
                {investedValue}
              </strong>
            </p>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="icon-content pledge">
            <img
              alt="Participation"
              className="icon"
              src="/img/small-participation.png"
            />
            <p className="inline-block f-s-20">
              Participación en la empresa:&nbsp;
              <br/>
              <strong>
                {equity} %
              </strong>
            </p>
          </div>
          <div className="icon-content pledge">
            <img
              alt="user"
              className="icon"
              src="/img/small-percent.png"
            />
            <p className="inline-block f-s-20">
              Corretaje {props.investment.fees}% + IVA:&nbsp;
              <br/>
              <strong>
                {feeValue}
              </strong>
              <br/>
            </p>
          </div>
        </div>
      </div>
      <div className="gap-20"/>
      <div className="row">
        <div className="col-md-6">
          <p className="b-grey text-center" style={{fontSize: 30, padding: 20}}>
            Total: <strong>{totalValue}</strong>
          </p>
        </div>
      </div>
      <div className="gap-30"/>
      <p className="text-left">
        <button
          className="btn btn-primary margin-r-10"
          onClick={() => props.handleModifyImport()}
        >
          <a
          >
            Modificar
          </a>
        </button>
        {
          props.questionId === undefined && props.investment.person!.personType === 'juridical' ?
          <button
            className="btn btn-secondary disabled"
            onClick={() => props.handleConfirmImport()}
          >
            Confirmar
          </button> :
          <button
            className="btn btn-secondary"
            onClick={() => props.handleConfirmImport()}
          >
            Confirmar
          </button>
        }
        
      </p>
      <div className="gap-50"/>
    </div>
  );
};

export default ConfirmImportComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-import/ConfirmImport.component.tsx